var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibleAlerts.length
    ? _c(
        "div",
        { staticClass: "wallet-alerts d-flex flex-column az-gap-small" },
        _vm._l(_vm.visibleAlerts, function(alert) {
          return _c(
            "BaseAlert",
            {
              key: alert.id,
              attrs: { icon: alert.icon, "icon-color": alert.iconColor },
              scopedSlots: _vm._u(
                [
                  {
                    key: "button",
                    fn: function() {
                      return [
                        alert.actionLabel
                          ? _c(
                              "BaseButton",
                              {
                                staticClass: "mx-10",
                                attrs: {
                                  small: "",
                                  dark: "",
                                  outline: "",
                                  "min-width": "80px",
                                  loading: alert.actionLoading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onAction(alert)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(alert.actionLabel) + " ")]
                            )
                          : _vm._e(),
                        alert.closable
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  "aria-label": "Fechar alerta"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onClose(alert)
                                  }
                                }
                              },
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: "close-circle",
                                    color: "secondary",
                                    size: "24"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [_vm._v(" " + _vm._s(alert.message) + " ")]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }